import React from "react"
import Navbar from "../../Common/Components/Navbar"
import Footer from "../../Common/Components/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import TimesheetComp from "./Component/TimesheetComp"

const Timesheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TimesheetComp />
        </div>
        <Footer />
        </>
    )
}

export default Timesheet